import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'

//Components
import TextField from '../../../components/TextField/TextField';

//Helpers
import { validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//Api
import pgrs_api from '../../../api/pgrs_api';

//Context
import { useAuth } from '../../../context/auth';

export default function IdentificacaoPGRS({ pgrs, setPgrs, errors, setErrors, campos }) {
  const { setLoading } = useAuth();

  const [optionsFormularioPGRS, setOptionsFormularioPGRS] = useState([]);

  function onChange(e) {
    const { name, value } = e.target;
    const _pgrs = {
      ...pgrs,
      [name]: value
    }

    const erros = validarCampos(campos, campos.filter(c => c.name == name));

    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }

    setPgrs((prev) => ({ ..._pgrs }))
  }

  //onChange para a questão vinculada
  const onChangeSearchable = (e, select) => {
    const { name } = select;

    const _pgrs = {
      ...pgrs,
      [name]: e != null ? e.value.toString() : null,
    };

    const erros = validarCampos(campos, campos.filter(c => c.name == name));

    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }

    setPgrs((prev) => ({ ..._pgrs }))
  }

  function loadFormulariosPGRS() {
    setLoading(true);
    pgrs_api.GetList()
      .then(response => {
        response.data = response.data.map(value => {
          value.label = value.identificacao;
          value.value = value.id;
          return value;
        });

        setOptionsFormularioPGRS(response.data);
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadFormulariosPGRS();
  }, []);

  return (
    <div className='p-2 m-2'>
      <Row>
        <Col md="12" lg="12">
          <TextField
            maxLength={"300"}
            label={"* Identificação do PGRS"}
            name={"identificacao"}
            value={pgrs.identificacao}
            onChange={onChange}
            invalid={!!errors.identificacao}
          />
        </Col>
        <Col md="12" lg="12">
          <TextField
            invalid={!!errors.tbFormularioPGRS_Id}
            label={"* Formulário"}
            name="tbFormularioPGRS_Id"
            searchable
            disabled={pgrs?.id && !!pgrs.tbFormularioPGRS_Id ? true : false}
            type={"select"}
            options={optionsFormularioPGRS}
            value={optionsFormularioPGRS?.filter(x => x.value == pgrs.tbFormularioPGRS_Id)[0]}
            onChange={onChangeSearchable}
          />
        </Col>
      </Row>
    </div>
  )
}
